import React from 'react';
import { useTranslation } from 'react-i18next';
var ProfileDropdownItem = function (_a) {
    var text = _a.text, url = _a.url, element = _a.element;
    var t = useTranslation().t;
    return (React.createElement("li", { className: "sdds-nav__avatar-item profile-drop-item" },
        url && React.createElement("a", { className: "sdds-nav__avatar-item-core", href: url }, t(text)),
        element));
};
export default ProfileDropdownItem;
